/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import {AgGridModule} from '@ag-grid-community/angular';
import {CommonModule} from "@angular/common";
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from "@angular/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterModule} from "@angular/router";
import {PatientTreatmentPlanModule} from "@doctor-panel-modules/patient-treatment-plan/patient-treatment-plan.module";
import {IonicModule} from "@ionic/angular";
import {MenuLateralComponent} from "@modules/base/components/menu-lateral/menu-lateral.component";
import {TrecToolbarComponent} from "@modules/base/components/trec-toolbar/trec-toolbar.component";
import {CreditsPageComponent} from "@modules/base/pages/credits-page/credits-page.component";
import {HomePageComponent} from "@modules/base/pages/home-page/home-page.component";
import {DoctorPanelState} from "@modules/doctor-panel/store/doctor-panel.state";
import {NgxsModule} from "@ngxs/store";
import {SharedUserAvatarModule} from "@shared/shared-user-avatar/shared-user-avatar.module";
import {TrecUtilsModule} from "@trec/api/utils";
import {C3AutocompleteModule} from "@trec/components/autocomplete";
import {C3DevLoginMenuModule} from "@trec/components/dev-login-menu";
import {C3GetIconModule} from "@trec/components/get-icon";
import {C3TooltipModule} from "@trec/components/tooltip";
import {VideoMeetingState} from "@video-meeting/store/video-meeting.state";
import {AccountQuickMenuComponent} from "./components/account-quick-menu/account-quick-menu.component";
import {ExternalToolsListComponent} from "./components/external-tools-list/external-tools-list.component";
import {MobileAppListComponent} from "./components/mobile-app-list/mobile-app-list.component";
import {NotificationCenterComponent} from "./components/notification-center/notification-center.component";
import {AssistantInfoModalComponent} from './components/voice-assistant/assistant-info-modal/assistant-info-modal.component';
import {AssistantChoosePatientModalComponent} from './components/voice-assistant/assistant-shared-modal/assistant-choose-patient-modal/assistant-choose-patient-modal.component';
import {AssistantTextModalComponent} from './components/voice-assistant/assistant-text-modal/assistant-text-modal.component';
import {VoiceAssistantFeatureComponent} from './components/voice-assistant/voice-assistant-feature/voice-assistant-feature.component';
import {ModalAddMultiPatientComponent} from "./pages/patient-group-page/modals/modal-add-multi-patient/modal-add-multi-patient.component";
import {ModalDetailMultiPatientComponent} from "./pages/patient-group-page/modals/modal-detail-multi-patient/modal-detail-multi-patient.component";
import {PatientGroupPageComponent} from "./pages/patient-group-page/patient-group-page.component";

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    NgxsModule.forFeature([VideoMeetingState, DoctorPanelState]),
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    FormsModule,
    IonicModule,
    AgGridModule,
    MatIconModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    MatTooltipModule,
    MatButtonModule,
    SharedUserAvatarModule,
    C3GetIconModule,
    C3TooltipModule,
    C3DevLoginMenuModule,
    TrecUtilsModule,
    C3AutocompleteModule,
    PatientTreatmentPlanModule
  ],
  declarations: [
    HomePageComponent,
    PatientGroupPageComponent,
    CreditsPageComponent,
    TrecToolbarComponent,
    MenuLateralComponent,
    AccountQuickMenuComponent,
    MobileAppListComponent,
    ExternalToolsListComponent,
    NotificationCenterComponent,
    ModalAddMultiPatientComponent,
    ModalDetailMultiPatientComponent,
    VoiceAssistantFeatureComponent,
    AssistantInfoModalComponent,
    AssistantTextModalComponent,
    AssistantChoosePatientModalComponent
  ],
  exports: [TrecToolbarComponent, MenuLateralComponent, NotificationCenterComponent, VoiceAssistantFeatureComponent],
})
export class BaseModule { }
